<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>
    <ion-title class="titulo">{{'Documentos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <sem-registro *ngIf="documentosList?.length === 0 && certificadosList?.length === 0"> </sem-registro>

  <ion-accordion-group>
    <ion-accordion value="first" *ngIf="documentosList.length != 0">
      <ion-item slot="header" lines="none" class="ion-margin-vertical">
        <i class="fa-solid fa-id-card ion-margin-end icon-list"></i>
        <ion-label>{{'Listagem de Documentos' | translate}}</ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-list *ngFor="let documento of documentosList;">
          <ion-item *ngIf="!documento.idEvento" class="ion-margin-bottom">
            <span>{{ documento.descricao }}</span>

            <ion-note slot="end" (click)="openPdf(documento.filename)">
              <i class="fal fa-cloud-download-alt icon-list"></i>
            </ion-note>
          </ion-item>
        </ion-list>
      </div>
    </ion-accordion>

    <ion-accordion value="second" *ngIf="certificadosList.length != 0">
      <ion-item slot="header" lines="none" class="ion-margin-vertical">
        <i class="fa-solid fa-graduation-cap ion-margin-end icon-list"></i>
        <ion-label>{{'Certificados de Eventos/Ensinos' | translate}}</ion-label>
      </ion-item>
      <div class="ion-padding" slot="content">
        <ion-list *ngFor="let certificado of certificadosList;">
          <ion-item class="ion-margin-bottom">
            <span>{{ certificado.tema || certificado.descricao }}</span>

            <ion-note slot="end" (click)="openPdf(certificado.filename)">
              <i class="fal fa-cloud-download-alt icon-list"></i>
            </ion-note>
          </ion-item>
        </ion-list>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</ion-content>
